import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import injectSheet from 'react-jss'
import QRCode from './qr'
import pure from 'recompose/pure'
import StyleGuide from 'aria-viewer/tour/constants/styleGuide'
import { MAIN_VR_INSTR_PANEL_ITEM } from 'aria-viewer/keyboard/constants/tabIndices'
import { hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import { getEnv } from 'aria-viewer/utils/environment'

const styleSheetContainer = {
    mainContainer: {
        position: 'absolute',
        left: 46,
        top: 19,
    },
    title: {
        fontSize: 22,
        color: StyleGuide.colors.white,
    },
    closeButton: {
        position: 'absolute',
        top: 32,
        right: 21,
        width: 14,
        height: 14,
        cursor: 'pointer',
    },
}

const styleSheetQRCode = {
    listContainer: {
        position: 'absolute',
        width: 320,
        marginTop: 40,
    },
    listSpacing: {
        marginBottom: 52,
    },
    listItem: {
        fontSize: 14,
        color: StyleGuide.colors.white,
        listStyleType: 'decimal',
    },
    qrCode: {
        marginTop: 23,
        marginBottom: 60,
    },
    deepLinkContainer: {
        marginTop: 24,
        width: '95%',
        wordBreak: 'break-word',
    },
    deepLink: {
        color: '#00CBF5',
        textDecoration: 'none',
        '&:visited': {
            color: '#4990E2',
        },
    },
}

const QRCodeContainer = pure(
    injectSheet(styleSheetQRCode)(function QRCodeContainer({ classes, deepLinkURL, locationTitle }) {
        return (
            <ul className={classes.listContainer}>
                <li className={classes.listItem} aria-label="View in VR QR Code">
                    Download {locationTitle} VR
                    <div className={classes.qrCode}>
                        <QRCode text={deepLinkURL} />
                    </div>
                </li>
                <li className={classes.listItem} aria-label="View in url">
                    Enter this URL into your mobile browser
                    <div className={classes.deepLinkContainer}>
                        <a
                            className={classes.deepLink}
                            target="_blank"
                            href={deepLinkURL}
                            tabIndex={MAIN_VR_INSTR_PANEL_ITEM}
                            rel="noreferrer"
                        >
                            {deepLinkURL}
                        </a>
                    </div>
                </li>
            </ul>
        )
    })
)

const VrInstructionContainer = pure(
    injectSheet(styleSheetContainer)(function VrInstructionContainer({
        classes,
        handleCloseButtonClick,
        deepLinkURL,
        locationTitle,
    }) {
        return (
            <div>
                <CloseButton
                    // TODO:
                    //  we are passing the style const directly to closebutton
                    //  since it inherits Button.jsx and we shouldnt pass
                    //  classes or style down the line when using jss.
                    //  This should be changed to JSS style once Button.jsx is
                    //  refactored
                    style={styleSheetContainer.closeButton}
                    tabIndex={MAIN_VR_INSTR_PANEL_ITEM}
                    onClick={handleCloseButtonClick}
                />

                <div className={classes.mainContainer}>
                    <div className={classes.title}>View in VR</div>

                    {deepLinkURL && <QRCodeContainer deepLinkURL={deepLinkURL} locationTitle={locationTitle} />}
                </div>
            </div>
        )
    })
)

class VRInstructionsPanel extends PureComponent {
    constructor(props) {
        super(props)

        const { location, locationsList } = this.props

        let remainder = location.inst_unique_id + (locationsList.length > 1 ? '/' + location.unique_id : '')

        this.state = {
            deepLinkURL: getEnv('REACT_APP_TINY_URL') + 'vr/' + remainder,
        }
    }

    render() {
        return (
            <VrInstructionContainer
                handleCloseButtonClick={this.props.hideDrawer}
                deepLinkURL={this.state.deepLinkURL}
                locationTitle={this.props.location.name}
            />
        )
    }
}

export default connect(mapSelectorsToProps(['location', 'locationsList']), {
    hideDrawer,
})(VRInstructionsPanel)
